import * as React from 'react';

class SimpleErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.error(
      'An error has occurred while rendering the component!',
      error,
      info,
    );
  }

  render() {
    if (this.state.hasError) {
      return 'Error';
    }

    return this.props.children;
  }
}

export default SimpleErrorBoundary;
